<div class="advanced-search">
  <h1 class="typography--title u-m-b-16">Contract Summary</h1>
  <div class="advanced-search__form-wrapper">
    <div class="advanced-search__form">
      <form name="schoolSearchForm" aria-label="Search for contract summary" novalidate [formGroup]="form" (ngSubmit)="onSearch()">
        <div class="advanced-search__field">
          <label for="fromDate" class="advanced-search__label">From Date</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="fromDate" formControlName="fromDate" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="toDate" class="advanced-search__label">To Date</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="toDate" formControlName="toDate" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="contractId" class="advanced-search__label">Contract Id</label>
          <div class="advanced-search__input">
            <input type="text" id="contractId" formControlName="contractId" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="orderId" class="advanced-search__label">Order Id</label>
          <div class="advanced-search__input">
            <input type="text" id="orderId" formControlName="orderId" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="contractNumber" class="advanced-search__label">Contract Number</label>
          <div class="advanced-search__input">
            <input type="text" id="contractNumber" formControlName="contractNumber" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="effectiveFrom" class="advanced-search__label">Effective From</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="effectiveFrom" formControlName="effectiveFrom" />
          </div>
        </div>
        <div class="row align-right">
          <div class="advanced-search__submit btn-group">
            <button type="submit" class="btn btn--elevated btn-group__btn">Search</button>
            <button type="button" class="btn btn--hollow btn--elevated btn-group__btn" (click)="onDownload()">Download</button>
          </div>
        </div>
      </form>
      <div class="full-page-spinner" [class.full-page-spinner--is-active]="(summarySearchState$ | async).loading">
        <div class="full-page-spinner__icon"></div>
      </div>
    </div>
  </div>
</div>
